# ------------------------------------*|
# #Editor Layout -> block Overlays
# ------------------------------------*|


moduleBlockOverlays = angular.module 'services.layoutEditor.blockOverlays', [
  "services.editorNamespace"
]

moduleBlockOverlays.factory 'blockOverlays', ["$timeout", "$injector", "ns", "blocksBuilder", ($timeout, $injector, ns, blocksBuilder) ->

  Y = undefined
  blockOverlay =
    init: (y) ->
      Y = y
      @addOverlaysToBlocks()
    overlayingWidgets: ["video"]
    addOverlaysToBlocks: ->
      self = @
      blocks = Y.all ns.blockClass
      blocks.each (block) ->
        newOverlay = Y.DOM.create "<div class='#{ns.blockOverlay.substr(1)}'></div>"
        inList = block.widget and block.widget.type in self.overlayingWidgets
        overlayExists = $(block._node).find(ns.blockOverlay).length
        if !overlayExists and inList
          $(block._node).find(ns.widgetWrapperClass).append newOverlay
    destroyOverlays: ->
      Y.all(ns.blockOverlay).remove()
  blockOverlay
]



// WEBPACK FOOTER //
// ./src/app/editor/services/layout_editor/blockOverlays.coffee